/**
 * PartnerLogos Component
 *
 * Displays partner logos (Saafe, CAMS, KFintech) in a horizontal row.
 * Uses text-based placeholders until real SVG logos are available.
 *
 * @example
 * ```tsx
 * <PartnerLogos />
 * ```
 */

import { cn } from "@/lib/utils";
import { PARTNERS } from "@/constants/trustCopy";

export interface PartnerLogosProps {
  className?: string;
}

export function PartnerLogos({ className }: PartnerLogosProps) {
  return (
    <div className={cn("flex flex-col items-center gap-3", className)}>
      <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
        Powered by trusted partners
      </p>
      <div
        className="flex flex-wrap items-center justify-center gap-6"
        role="list"
        aria-label="Trusted partners"
      >
        {PARTNERS.map((partner) => (
          <div
            key={partner.id}
            className="flex flex-col items-center gap-1"
            role="listitem"
          >
            {/* Placeholder logo — replace with <img> or inline SVG when assets are available */}
            <div className="flex h-10 w-20 items-center justify-center rounded-md border border-border bg-muted/40 text-sm font-semibold text-muted-foreground">
              {partner.name}
            </div>
            <span className="text-[10px] text-muted-foreground/70">
              {partner.description}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
